<template>
    <v-dialog v-model="dialogOpen" max-width="800px">
        <v-card>
            <toolbar-page title="Creating new variable" disable-icon help="data-variable-types">
                <template slot="buttons">
                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>
            </toolbar-page>

            <v-stepper v-model="stepperModel">
                <v-stepper-header>
                    <v-stepper-step :complete="stepperModel > 1" step="1">Variable type</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepperModel > 2" step="2">Locale</v-stepper-step>

                    <v-divider></v-divider>

                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">

                        <type-selection-box v-for="type in types"
                                            :key="type"
                                            @select="typeSelected"
                                            :type="type"/>

                    </v-stepper-content>

                    <v-stepper-content step="2">

                        <div class="d-flex flex-wrap">

                            <v-alert type="info" class="body-2">
                                Select the base locale you would like to start with. You can add more locales later on.
                            </v-alert>

                            <div v-for="locale in localesPanel" :key="locale.id" style="width: 250px">
                                <locale v-if="locale.image"
                                        :data="locale"
                                        :editable="false"
                                        clickable
                                        @click="localeSelected">
                                </locale>
                            </div>
                        </div>

                    </v-stepper-content>

                </v-stepper-items>
            </v-stepper>

        </v-card>
    </v-dialog>
</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';
import IconTile from '../../../components/UI/IconTile';
import LocaleSelector from '../../../components/UI/LocaleSelector';
import TypeSelectionBox from "./TypeSelectionBox";
import Locale from "../../../components/UI/Locale";

export default {

    components: {
        Locale,
        ToolbarPage,
        IconTile,
        LocaleSelector,
        TypeSelectionBox
    },

    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        types: {
            type: Array,
            required: true,
        }
    },

    computed: {
        localesSelected: {
            get() {
                if (!this.locales) {
                    this.locales = this.$store.state.PanelSettings.settings.locales;
                }
                return this.locales;
            },
            set(locales) {
                this.locales = locales;
            }
        },

        localesPanel() {
            return this.$store.state.PanelSettings.settings.locales;
        },

        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        }
    },

    data() {
        return {
            stepperModel: null,

            // Data variable create settings
            type: null,
            locale: null,
        }
    },

    methods: {

        // Step 1
        typeSelected(typeSelected) {
            this.stepperModel = 2;
            this.type = typeSelected;

            // Select single locale automatically
            if (this.localesPanel.length === 1) {
                this.locale = Object.assign({},this.localesPanel[0]);
                this.emit();
                this.closeDialog();
            }
        },

        // Step 2
        localeSelected(locale) {
            this.locale = locale;
            this.emit();
            this.closeDialog();
        },

        // Step 3
        emit() {
            this.$emit('change', {type: this.type, locales: [this.locale]});
        },

        closeDialog() {
            this.$emit('input', false);
        },
    }
}
</script>
